import { render, staticRenderFns } from "./CrudInput.vue?vue&type=template&id=e47bf7f4&scoped=true"
import script from "./CrudInput.vue?vue&type=script&lang=js"
export * from "./CrudInput.vue?vue&type=script&lang=js"
import style0 from "./CrudInput.vue?vue&type=style&index=0&id=e47bf7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47bf7f4",
  null
  
)

export default component.exports